<section class="contact section" id="contact">
  <div class="shell-container reveal" appRevealOnScroll="80ms">
    <div class="contact__header">
      <div class="badge">{{ content.badge }}</div>
      <h2>{{ content.heading }}</h2>
      <p class="contact__lede">{{ content.lede }}</p>
    </div>

    <form class="contact__form" [formGroup]="contactForm" (ngSubmit)="submitContact()" novalidate>
      <div class="contact__grid">
        <div class="contact__field">
          <label for="contact-name">Full name</label>
          <input id="contact-name" type="text" formControlName="name" placeholder="Your name" />
          <p class="contact__error" *ngIf="contactSubmitted && contactForm.get('name')?.invalid">
            Please enter your name (at least 2 characters).
          </p>
        </div>

        <div class="contact__field">
          <label for="contact-email">Email address</label>
          <input id="contact-email" type="email" formControlName="email" placeholder="you@example.com" />
          <p class="contact__error" *ngIf="contactSubmitted && contactForm.get('email')?.invalid">
            Please enter a valid email address.
          </p>
        </div>

        <div class="contact__field">
          <label for="contact-phone">Phone number</label>
          <input id="contact-phone" type="tel" formControlName="phone" placeholder="+44 00 0000 0000" />
          <p class="contact__error" *ngIf="contactSubmitted && contactForm.get('phone')?.invalid">
            Please enter a valid phone number.
          </p>
        </div>

        <div class="contact__field contact__field--full">
          <label for="contact-comment">How can we help?</label>
          <textarea
            id="contact-comment"
            rows="4"
            formControlName="comment"
            placeholder="Tell us about your pet, temperament, and grooming needs."
          ></textarea>
          <p class="contact__error" *ngIf="contactSubmitted && contactForm.get('comment')?.invalid">
            Please add a short message (at least 10 characters).
          </p>
        </div>
      </div>

      <div class="contact__actions">
        <button class="btn btn--primary" type="submit" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Sending...' : 'Send Message' }}
        </button>
        <p class="contact__note">{{ content.note }}</p>
      </div>

      <p class="contact__status contact__status--success" *ngIf="isSubmitSuccess">
        Thank you, we've received your message and will be in touch shortly.
      </p>
      <p class="contact__status contact__status--error" *ngIf="hasSubmitError">
        Something went wrong. Please try again.
      </p>
    </form>
  </div>
</section>
